import { render, staticRenderFns } from "./MensagemErro.vue?vue&type=template&id=06bd456d"
import script from "./MensagemErro.vue?vue&type=script&lang=js"
export * from "./MensagemErro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports